<ng-container *transloco="let t; read: 'upload-map'">
  <div class="content-padding upload-map__content">
    @if (isLoadingUpload$ | async) {
      <div class="upload-map__loading">
        @if (upload?.document_count) {
          <p>
            {{ t('waiting-for-inspection', { docCount: upload.document_count }) }}
          </p>
        }
        <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
      </div>
    }
    @if (isError) {
      <div class="upload-map__error">
        <div>
          <p class="kxi-text-normal">{{ t('there-was-unrecoverable-error') }}</p>
          <blockquote>{{ upload.message }}</blockquote>
          <p class="kxi-text-normal">
            {{ t('to-delete-this-upload') }}
          </p>
          <span class="upload-map__delete-button">
            <xi-default-button
              color="warning"
              [text]="t('delete')"
              (onClick)="deleteOnError()"
            ></xi-default-button>
          </span>
          <xi-default-button
            [text]="t('save-for-later')"
            (onClick)="navigateBack()"
          ></xi-default-button>
        </div>
      </div>
    }
    @if ((isLoadingUpload$ | async) === false && !isError) {
      <div>
        <div>
          <h1 class="upload-map__header">{{ t('field-setup') }}</h1>
        </div>
        <p class="upload-map__page-header-fields">
          <span class="upload-map__page-header-fields-title">{{ t('collection-name') }}:</span>
          <span class="upload-map__page-header-fields-data">{{ collectionDisplayName }}</span>
          <span [matTooltip]="upload.file_name" class="upload-map__page-header-fields-title"
            >{{ t('file-name') }}:</span
          >
          <span class="upload-map__page-header-fields-data">{{
            upload.file_name | truncate: 30
          }}</span>
        </p>
        <div class="upload-map__options_and_info">
          <div class="upload-map__options">
            <xi-toggle-switch
              #autoIDToggle
              [label]="t('auto-create-ids')"
              [leftText]="t('off')"
              [rightText]="t('on')"
              (onToggle)="onAutoIDToggle($event.detail.isToggled)"
              [isLabelInline]="false"
              [isToggled]="autoCreateIds"
            ></xi-toggle-switch>
            @if (showFirstRowOptions) {
              <div>
                <xi-toggle-switch
                  size="normal"
                  [label]="t('first-row-contains')"
                  [leftText]="t('column-name')"
                  [rightText]="t('data')"
                  [changeColorOnToggle]="false"
                  [isLabelInline]="false"
                  [isToggled]="!upload.metadata.firstRecordAsHeader"
                  (onToggle)="reinspectWithFirstRowHeaders($event.detail.isToggled)"
                ></xi-toggle-switch>
              </div>
            }
            @if (showDialectOptions) {
              <div>
                <xi-toggle-switch
                  size="normal"
                  [label]="t('delimeter-used')"
                  [leftText]="t('comma')"
                  [rightText]="t('tab')"
                  [changeColorOnToggle]="false"
                  [isLabelInline]="false"
                  (onToggle)="reinspectWithDelimiter($event.detail.isToggled)"
                  [isToggled]="upload.metadata.delimiter === ',' ? false : true"
                ></xi-toggle-switch>
              </div>
            }
            @if (showFirstRowOptions) {
              <div>
                <xi-dropdown
                  [label]="t('encoding-used')"
                  [placeholder]="t('select-encoding')"
                  [data]="encodingsUsed"
                  (onValueChange)="reinspectWithEncoding($event.detail.selected.id)"
                  [value]="upload.metadata.encoding || 'None'"
                ></xi-dropdown>
              </div>
            }
            <div>
              <div class="kxi-text-small timezonebutton">{{ t('timezone-mapping') }}</div>
              <div [matTooltip]="uploadTimezoneTooltip">
                <xi-default-button
                  [stretch]="true"
                  buttonSize="large"
                  iconLeft="clock_2"
                  text="{{ uploadTimezoneOffset }}"
                  fill="text"
                  (onClick)="openTimezoneModal()"
                >
                </xi-default-button>
              </div>
            </div>
          </div>
          <div class="upload-map__info-container">
            <h4 class="upload-map__info-title">{{ t('summary') }}</h4>
            <div class="upload-map__info">
              <div class="upload-map__info-data-container">
                <div class="upload-map__info-data">
                  <span>{{ t('rows-found') }}:</span>
                  <span> {{ upload.document_count }}</span>
                </div>
                <div class="upload-map__info-data">
                  <span>{{ t('to-analyze') }}:</span>
                  <span> {{ autoFoundCount() + manualCount() }}</span>
                </div>
              </div>
              <div class="upload-map__info-data-container">
                <div class="upload-map__info-data">
                  <span>{{ t('columns-mapped') }}:</span>
                  <span>{{ upload?.metadata.columns.length }}</span>
                </div>
                <div class="upload-map__info-data">
                  <span>{{ t('automatic') }}:</span>
                  <span>{{ autoFoundCount() }}</span>
                </div>
              </div>
              <div class="upload-map__info-data-container">
                <div class="upload-map__info-data">
                  <span>{{ t('manual') }}:</span>
                  <span>{{ manualCount() }}</span>
                </div>
                <div class="upload-map__info-data">
                  <span>{{ t('not-included') }}:</span>
                  <span>{{ notIncludedCount() }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="upload-map__column-map-table-wrapper">
          <form [formGroup]="fieldForm">
            <table class="upload-map__column-map-table">
              <tr>
                @for (column of upload?.metadata.columns; track column; let i = $index) {
                  <td class="upload-map__column-map-cell upload-map__column-map-field-select-cell">
                    <mat-form-field class="upload-map__column-form-field" floatLabel="never">
                      <div class="upload-map__input-container">
                        <input
                          matInput
                          type="text"
                          [placeholder]="'- ' + t('do-not-include') + ' -'"
                          formControlName="fieldGroup{{ i }}"
                          [matAutocomplete]="auto"
                          name="{{ 'field' + i }}"
                          class="upload-map__column-input"
                          [ngClass]="{
                            'upload-map__text-red':
                              !isOKFieldName(column.field_name) ||
                              !isUniqueFieldName(column.field_name),
                          }"
                          tabindex="1"
                        />
                        <div
                          [ngClass]="
                            autoCompleteOpened === column
                              ? 'upload-map__column-form-dropdown--open'
                              : 'upload-map__column-form-dropdown--closed'
                          "
                        >
                          <xi-icon icon="single_arrow_down"></xi-icon>
                        </div>
                      </div>
                      @if (fieldForm.get('fieldGroup' + i).hasError('hasDuplicate')) {
                        <mat-error>{{ t('duplicate-values') }}</mat-error>
                      }
                      @if (!column.field_name) {
                        <mat-hint></mat-hint>
                      }
                      @if (column.field_name && isCustomFieldName(column.field_name)) {
                        <mat-hint>
                          {{ t('custom-field') }} (
                          @if (isNewCustomField(column.field_name)) {
                            <a (click)="chooseFieldTypes(column.field_name)">{{
                              getFieldType(column.field_name) || t('configure')
                            }}</a>
                          }
                          @if (!isNewCustomField(column.field_name)) {
                            <span>{{ getFieldType(column.field_name) }}</span>
                          }
                          )</mat-hint
                        >
                      }
                      @if (column.field_name && isStandardFieldName(column.field_name)) {
                        <mat-hint>{{ t('standard-field') }}</mat-hint>
                      }
                      @if (column.field_name && !isOKFieldName(column.field_name)) {
                        <mat-hint class="upload-map__text-red">{{
                          getInvalidNameText(column.field_name)
                        }}</mat-hint>
                      }
                      @if (
                        column.field_name && isOKFieldName && !isUniqueFieldName(column.field_name)
                      ) {
                        <mat-hint class="upload-map__text-red"
                          >{{ t('similar-name-exists') }}
                        </mat-hint>
                      }
                      <mat-autocomplete
                        #auto="matAutocomplete"
                        (opened)="autoCompleteOpened = column"
                        (closed)="autoCompleteOpened = null"
                      >
                        @for (group of fieldGroupOptions[i] | async; track group) {
                          <mat-optgroup [label]="group.label">
                            @for (option of group.fields; track option) {
                              <mat-option
                                [value]="option"
                                (onSelectionChange)="onACSelectionChange($event, option, column)"
                                >{{ option }}</mat-option
                              >
                            }
                          </mat-optgroup>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                  </td>
                }
              </tr>
            </table>
          </form>
          <table class="upload-map__samples-table">
            <tr>
              @for (column of upload?.metadata.columns; track column) {
                <th class="upload-map__column-map-cell">
                  {{ column.column_name }}
                  <app-lex-icon-button
                    color="white"
                    class="upload-map__samples-table-text-edit"
                    svgIcon="xi_edit"
                    [tooltip]="t('advanced-column-configuration')"
                    (click)="onEditTransformation(column)"
                  ></app-lex-icon-button>
                </th>
              }
            </tr>
            @for (row of samples; track $index; let i = $index) {
              <tr>
                @for (value of row; track $index; let j = $index) {
                  <td
                    #columnSampleValue
                    class="upload-map__column-map-cell upload-map__column-sample-cell"
                    [ngClass]="
                      !upload.metadata.columns[j].field_name
                        ? 'upload-map__column-sample-cell--unmapped '
                        : ''
                    "
                  >
                    {{ value }}
                  </td>
                }
              </tr>
            }
          </table>
        </div>
        <div class="upload-map__warnings">
          <div>
            @if (!areRequiredFieldsMapped()) {
              <div>
                <div class="upload-map__warning">
                  <xi-icon icon="warning_filled" color="error" iconSize="large"></xi-icon>
                  <p>{{ t('required-fields-missing') }}</p>
                </div>
              </div>
            }
            @if (!areAllFieldsValid()) {
              <div>
                <div class="upload-map__warning">
                  <xi-icon icon="warning_filled" color="error" iconSize="large"></xi-icon>
                  <p>{{ t('fix-invalid-field-mappings') }}</p>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>

  @if ((isLoadingUpload$ | async) === false && !isError) {
    <div class="upload-map__bottom-section">
      @if (hasDateColumn) {
        <div class="upload-map__timezone-mapping">
          {{ t('timezone-mapping') }} {{ uploadTimezoneOffset }}
        </div>
      }
      <div class="upload-map__action-buttons">
        <xi-default-button
          [text]="t('accept-all-names')"
          fill="text"
          buttonSize="large"
          (onClick)="acceptAllNames()"
          [tabindex]="4"
        ></xi-default-button>
        <xi-default-button
          [text]="t('cancel')"
          fill="text"
          buttonSize="large"
          (onClick)="cancel()"
          [tabindex]="3"
        ></xi-default-button>
        <div class="xi-loader-button-container">
          <xi-default-button
            [text]="t('save-to-collection')"
            buttonSize="large"
            [disabled]="!isMappingComplete() || !!(isLoadingConfirm$ | async)"
            (onClick)="uploadMetadata()"
            [tabindex]="2"
          ></xi-default-button>
          @if (isLoadingConfirm$ | async) {
            <div class="xi-loader-container__inline-overlay">
              <xi-animation
                [height]="100"
                [width]="100"
                [loop]="true"
                animation="cx_loader"
              ></xi-animation>
            </div>
          }
        </div>
      </div>
    </div>
  }

  <!--Timezone Modal-->
  @if (showTimezoneModal) {
    <app-lex-xi-modal
      [isVisible]="showTimezoneModal"
      maxWidth="500px"
      (close)="onTimezoneModalClosed('')"
    >
      <ng-template appXIModalContent>
        @if (showTimezoneModal) {
          <app-account-change-timezone
            [options]="{
              currentValue: uploadTimezone,
              defaultValue: timezoneService.defaultTimezone,
            }"
            (modalClosed)="onTimezoneModalClosed($event)"
          ></app-account-change-timezone>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
</ng-container>
